import * as api from './api';
import { Setting, Request } from '../';
import { sleep } from '@yichui/js-contrib/src/utils';

// 防并发请求
let doing_user = false; //

//
const state = {
  cmsUser: {}, // 模块用户信息
};

//
const mutations = {
  updateState(state, payload) {
    const keys = Object.keys(payload);
    keys.forEach(key => {
      state[key] = payload[key];
    });
  },
  SET_CMS_USER: (state, data) => {
    state.cmsUser = Object.assign({}, data);
  },
};

//
const actions = {
  // 我的信息
  async cmsUser({ state, commit }, params) {
    if (doing_user) {
      // 并发等结果
      while (doing_user) {
        await sleep(50);
      }
    } else {
      //
      try {
        doing_user = true;
        //
        const data = await api.cmsUser(params);
        // console.log('cmsUser', data);
        if (data) {
          commit('SET_CMS_USER', data);
        }
      } catch (err) {
        // 未知错误
        // console.error(`cmsUser`, err);
        commit('SET_CMS_USER', {});
      } finally {
        doing_user = false;
      }
    }
    return state.cmsUser;
  },
};

//
const getters = {};

//
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
